import React from "react";
import timezones from "assets/timezones";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormFooter from "forms/components/FormFooter";
import FormRow from "forms/components/FormRow";
import { DropdownField, FileField, RenderField } from "forms/fields";
import PropTypes from "prop-types";

import CancelButton from "components/CancelButton";
import SubmitButton from "components/SubmitButton";
import formatDuration from "utils/format/formatDuration";
import { getLocales } from "utils/locale";
import Translate from "utils/translate";
import { isRequired } from "utils/validation";

import styles from "forms/forms.css";

const { t } = new Translate("UserConfirmModal");

const timezoneExtractor = (tz) => {
  const zone = timezones.find((z) => z.timezone === tz);

  return zone && `${zone.city} (UTC ${formatDuration(zone.utc_offset)})`;
};

const UserConfirmForm = ({ handleSubmit, isBroker, isMobile, isSubmitting, onCancel }) => (
  <form className={styles.form} onSubmit={handleSubmit}>
    <div className={styles.wrapper}>
      {!isMobile && (
        <div className={styles.left}>
          <Field component={FileField} name="photo" isPicture />
        </div>
      )}
      <div className={styles.right}>
        <FormContainer title="Details">
          <FormRow>
            <Field
              component={RenderField}
              label={t("user.fname")}
              name="fname"
              validate={isRequired}
            />
            <Field
              component={RenderField}
              label={t("user.lname")}
              name="lname"
              validate={isRequired}
            />
          </FormRow>
          <FormRow>
            <Field
              component={RenderField}
              label={t("user.email")}
              name="email"
              validate={isRequired}
            />
            {isBroker ? (
              <Field component={RenderField} label={t("user.licenseNumber")} name="licenseNumber" />
            ) : (
              <Field component={RenderField} label={t("user.phone")} name="phone" />
            )}
          </FormRow>
          <FormRow>
            <Field
              autocomplete="new-password"
              component={RenderField}
              label={t("user.password")}
              name="password"
              type="password"
              validate={isRequired}
            />
            <Field
              autocomplete="new-password"
              component={RenderField}
              label={t("user.passwordConfirmation")}
              name="passwordConfirmation"
              type="password"
              validate={isRequired}
            />
          </FormRow>
        </FormContainer>
        <FormContainer title="Regional">
          <FormRow>
            <Field
              component={DropdownField}
              label={t("user.locale")}
              name="locale"
              validate={isRequired}
              valueExtractor={(locale) => t(`languages.${locale}`)}
              values={getLocales()}
            />
            <Field
              component={DropdownField}
              label={t("user.timezone")}
              name="timezone"
              validate={isRequired}
              valueExtractor={timezoneExtractor}
              values={timezones.map((tz) => tz.timezone)}
            />
          </FormRow>
        </FormContainer>
      </div>
    </div>

    <FormFooter>
      <CancelButton onClick={onCancel} forceLeftAlign />
      <SubmitButton
        isSubmitting={isSubmitting}
        submitLabel={t("confirm")}
        submittingLabel={t("confirming")}
      />
    </FormFooter>
  </form>
);

UserConfirmForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isBroker: PropTypes.bool,
  isMobile: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

export default UserConfirmForm;
